// Assigns jQuery to theme.jQuery after deferred jQuery loads.
// This file must remain external (not inline) so defer works correctly.
window.theme = window.theme || {};
theme.jQuery = window.jQuery;
